export enum AlertModalEnum {
    ActivateSimCard = 'ActiveSimCard',
    InvoiceSituation = 'InvoiceSituation'
}